import React, { useState, useEffect } from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import { useData } from '../../hooks';
import Alert from '@mui/material/Alert';

const HelpDesk = () => {
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { user, appIsReady } = useData();

  useEffect(() => {
    if (appIsReady && user) {
      openHelpdesk();
    }
  }, [user, appIsReady]);

  const openHelpdesk = async () => {
    const url = 'http://pf.kakao.com/_XWbxeG/chat';
    try {
      window.open(url, '_blank');
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3} ml={3}>
        <MDTypography variant='h6'>
          브라우저에서 로그인을 하시면 카카오톡 고객센터로 연결됩니다.
        </MDTypography>
        <MDTypography variant='h6'>
          새창이 열리지 않을 경우 아래의 주소를 브라우저에서 실행하세요.
        </MDTypography>
        <MDTypography variant='h6' pt={2}>
          http://pf.kakao.com/_XWbxeG/chat
        </MDTypography>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default HelpDesk;
